import { getAgeLevelTag, getEditionColor } from './utils';

interface CalibrationTagsProps {
  classVersion: string;
  ageLevelGroup: string;
}

function CalibrationTags({
  classVersion,
  ageLevelGroup
}: CalibrationTagsProps) {
  const ageLevel = getAgeLevelTag(classVersion, ageLevelGroup);
  const tagClassName =
    'rounded-[7px] px-2.5 py-1 text-[11px] font-bold leading-[normal]';

  return (
    <div className="flex flex-wrap gap-1.5 md:gap-[7px]">
      <span
        className={`${tagClassName} text-white ${getEditionColor(classVersion)}`}
      >
        {classVersion}
      </span>
      <span className={`${tagClassName} ${ageLevel.color}`}>
        {ageLevel.label}
      </span>
    </div>
  );
}

export default CalibrationTags;
